import React from 'react';

const ShareIcon = ({ color = "#7D878F" }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.8697 10.8492L13.3894 1.2002V6.75178C6.87743 7.947 3.4562 12.2286 2.08499 18.875L1.19995 23.1649L3.79808 19.6384C6.20492 16.3715 8.98099 14.8968 13.3894 14.7162V20.1596L23.8697 10.8492ZM15.3094 8.40594V5.57773L21.0074 10.8237L15.3094 15.8857V12.7772H14.3494C10.4426 12.7772 7.51552 13.624 5.0988 15.5097C6.76846 11.5649 9.70316 9.18205 14.4811 8.52062L15.3094 8.40594Z"
      fill={color}
    />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="1"
      y="1"
      width="23"
      height="23"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.8697 10.8492L13.3894 1.2002V6.75178C6.87743 7.947 3.4562 12.2286 2.08499 18.875L1.19995 23.1649L3.79808 19.6384C6.20492 16.3715 8.98099 14.8968 13.3894 14.7162V20.1596L23.8697 10.8492ZM15.3094 8.40594V5.57773L21.0074 10.8237L15.3094 15.8857V12.7772H14.3494C10.4426 12.7772 7.51552 13.624 5.0988 15.5097C6.76846 11.5649 9.70316 9.18205 14.4811 8.52062L15.3094 8.40594Z"
        fill="white"
      />
    </mask>
  </svg>
);

export default ShareIcon;
